import { j as Y } from "../../jsx-runtime-82a9ddf6.js";
import * as P from "react";
import { useRef as v, useState as I, useEffect as E, useCallback as N, useLayoutEffect as G } from "react";
var J = process.env.NODE_ENV === "production";
function X(e, t) {
  if (!J) {
    if (e)
      return;
    var n = "Warning: " + t;
    typeof console < "u" && console.warn(n);
    try {
      throw Error(n);
    } catch {
    }
  }
}
/**
  * react-collapsed v4.2.0
  *
  * Copyright (c) 2019-2024, Rogin Farrer
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE.md file in the root directory of this source tree.
  *
  * @license MIT
  */
var Z = class extends Error {
  constructor(e) {
    super(`react-collapsed: ${e}`);
  }
}, T = (...e) => X(e[0], `[react-collapsed] -- ${e[1]}`);
function W(e) {
  const t = v(e);
  return E(() => {
    t.current = e;
  }), N((...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function O(e, t, n) {
  const [r, s] = I(t), l = v(typeof e < "u"), m = l.current ? e : r, g = W(n), p = N(
    (h) => {
      const x = typeof h == "function" ? h(m) : h;
      l.current || s(x), g == null || g(x);
    },
    [g, m]
  );
  return E(() => {
    T(
      !(l.current && e == null),
      "`isExpanded` state is changing from controlled to uncontrolled. useCollapse should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled collapse for the lifetime of the component. Check the `isExpanded` prop."
    ), T(
      !(!l.current && e != null),
      "`isExpanded` state is changing from uncontrolled to controlled. useCollapse should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled collapse for the lifetime of the component. Check the `isExpanded` prop."
    );
  }, [e]), [m, p];
}
var ee = "(prefers-reduced-motion: reduce)";
function te() {
  const [e, t] = I(!1);
  return E(() => {
    if (typeof window > "u" || typeof window.matchMedia != "function")
      return;
    const n = window.matchMedia(ee);
    t(n.matches);
    const r = (s) => {
      t(s.matches);
    };
    if (n.addEventListener)
      return n.addEventListener("change", r), () => {
        n.removeEventListener("change", r);
      };
    if (n.addListener)
      return n.addListener(r), () => {
        n.removeListener(r);
      };
  }, []), e;
}
var ne = P["useId".toString()] || (() => {
});
function re() {
  return ne() ?? "";
}
var oe = typeof window < "u" ? P.useLayoutEffect : P.useEffect, $ = !1, ie = 0, H = () => ++ie;
function se(e) {
  const t = e || ($ ? H() : null), [n, r] = P.useState(t);
  return oe(() => {
    n === null && r(H());
  }, []), P.useEffect(() => {
    $ === !1 && ($ = !0);
  }, []), n != null ? String(n) : void 0;
}
function ce(e) {
  const t = re(), n = se(e);
  return typeof e == "string" ? e : typeof t == "string" ? t : n;
}
function ae(e, t) {
  const n = performance.now(), r = {};
  function s() {
    r.id = requestAnimationFrame((l) => {
      l - n > t ? e() : s();
    });
  }
  return s(), r;
}
function K(e) {
  e.id && cancelAnimationFrame(e.id);
}
function B(e) {
  return e != null && e.current ? e.current.scrollHeight : (T(
    !0,
    "Was not able to find a ref to the collapse element via `getCollapseProps`. Ensure that the element exposes its `ref` prop. If it exposes the ref prop under a different name (like `innerRef`), use the `refKey` property to change it. Example:\n\nconst collapseProps = getCollapseProps({refKey: 'innerRef'})"
  ), 0);
}
function le(e) {
  if (!e || typeof e == "string")
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function ue(e, t) {
  if (e != null)
    if (typeof e == "function")
      e(t);
    else
      try {
        e.current = t;
      } catch {
        throw new Z(`Cannot assign value "${t}" to ref "${e}"`);
      }
}
function D(...e) {
  return e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      ue(n, t);
    });
  };
}
function de(e) {
  let t = (n) => {
  };
  t = (n) => {
    if (!(n != null && n.current))
      return;
    const { paddingTop: r, paddingBottom: s } = window.getComputedStyle(n.current);
    T(
      !(r && r !== "0px" || s && s !== "0px"),
      `Padding applied to the collapse element will cause the animation to break and not perform as expected. To fix, apply equivalent padding to the direct descendent of the collapse element. Example:

Before:   <div {...getCollapseProps({style: {padding: 10}})}>{children}</div>

After:   <div {...getCollapseProps()}>
             <div style={{padding: 10}}>
                 {children}
             </div>
          </div>`
    );
  }, E(() => {
    t(e);
  }, [e]);
}
var fe = typeof window > "u" ? E : G;
function pe({
  duration: e,
  easing: t = "cubic-bezier(0.4, 0, 0.2, 1)",
  onTransitionStateChange: n = () => {
  },
  isExpanded: r,
  defaultExpanded: s = !1,
  hasDisabledAnimation: l,
  id: m,
  ...g
} = {}) {
  const p = W(n), h = ce(m ? `${m}` : void 0), [u, x] = O(
    r,
    s
  ), S = v(u), [j, L] = I(!1), U = te(), q = l ?? U, y = v(), w = v(), d = v(null), [k, V] = I(null);
  de(d);
  const C = `${g.collapsedHeight || 0}px`;
  function b(i) {
    if (!d.current)
      return;
    const c = d.current;
    for (const a in i) {
      const f = i[a];
      f ? c.style[a] = f : c.style.removeProperty(a);
    }
  }
  return fe(() => {
    if (!d.current || u === S.current)
      return;
    S.current = u;
    function c(o) {
      return q ? 0 : e ?? le(o);
    }
    const a = (o) => `height ${c(o)}ms ${t}`, f = (o) => {
      function R() {
        u ? (b({
          height: "",
          overflow: "",
          transition: "",
          display: ""
        }), p("expandEnd")) : (b({ transition: "" }), p("collapseEnd")), L(!1);
      }
      w.current && K(w.current), w.current = ae(R, o);
    };
    return L(!0), u ? y.current = requestAnimationFrame(() => {
      p("expandStart"), b({
        display: "block",
        overflow: "hidden",
        height: C
      }), y.current = requestAnimationFrame(() => {
        p("expanding");
        const o = B(d);
        f(c(o)), d.current && (d.current.style.transition = a(o), d.current.style.height = `${o}px`);
      });
    }) : y.current = requestAnimationFrame(() => {
      p("collapseStart");
      const o = B(d);
      f(c(o)), b({
        transition: a(o),
        height: `${o}px`
      }), y.current = requestAnimationFrame(() => {
        p("collapsing"), b({
          height: C,
          overflow: "hidden"
        });
      });
    }), () => {
      y.current && cancelAnimationFrame(y.current), w.current && K(w.current);
    };
  }, [
    u,
    C,
    q,
    e,
    t,
    p
  ]), {
    isExpanded: u,
    setExpanded: x,
    getToggleProps(i) {
      const { disabled: c, onClick: a, refKey: f, ...o } = {
        refKey: "ref",
        onClick() {
        },
        disabled: !1,
        ...i
      }, R = k ? k.tagName === "BUTTON" : void 0, _ = i == null ? void 0 : i[f || "ref"], A = {
        id: `react-collapsed-toggle-${h}`,
        "aria-controls": `react-collapsed-panel-${h}`,
        "aria-expanded": u,
        onClick(z) {
          c || (a == null || a(z), x((Q) => !Q));
        },
        [f || "ref"]: D(_, V)
      }, F = {
        type: "button",
        disabled: c ? !0 : void 0
      }, M = {
        "aria-disabled": c ? !0 : void 0,
        role: "button",
        tabIndex: c ? -1 : 0
      };
      return R === !1 ? { ...A, ...M, ...o } : R === !0 ? { ...A, ...F, ...o } : {
        ...A,
        ...F,
        ...M,
        ...o
      };
    },
    getCollapseProps(i) {
      const { style: c, refKey: a } = { refKey: "ref", style: {}, ...i }, f = i == null ? void 0 : i[a || "ref"];
      return {
        id: `react-collapsed-panel-${h}`,
        "aria-hidden": !u,
        "aria-labelledby": `react-collapsed-toggle-${h}`,
        role: "region",
        ...i,
        [a || "ref"]: D(d, f),
        style: {
          boxSizing: "border-box",
          ...!j && !u ? {
            // collapsed and not animating
            display: C === "0px" ? "none" : "block",
            height: C,
            overflow: "hidden"
          } : {},
          // additional styles passed, e.g. getCollapseProps({style: {}})
          ...c
        }
      };
    }
  };
}
const ge = ({ children: e, isOpen: t, className: n }) => {
  const [r, s] = I(!1), { getCollapseProps: l } = pe({ isExpanded: r });
  return E(() => {
    s(!!t);
  }, [t]), /* @__PURE__ */ Y.jsx("div", { className: n, ...l(), children: e });
};
export {
  ge as Collapse
};
